import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FileOptionProvider } from 'Components/UI/FileOption/FileOptionContext';
import FileOptionList from 'Components/UI/FileOption/FileOptionList';
import { Box } from '@material-ui/core';
import { noop } from 'Helpers/PropTypes';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
  },
});


function LinkFileView({
  classes, fileOptionLink, onLink,
}) {
  return (
    <Box className={classes.root}>
      <Box p={2}>
        <div className={classes.container}>
          <FileOptionProvider fileOptionLink={fileOptionLink}>
            <FileOptionList onLink={onLink} />
          </FileOptionProvider>
        </div>
      </Box>
    </Box>
  );
}

LinkFileView.defaultProps = {
  onLink: noop,
};

LinkFileView.propTypes = {
  onLink: PropTypes.func,
  fileOptionLink: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkFileView);
